import React, { useContext, useMemo } from 'react';

import { Container } from '../common';
import type { EventTypeEvaluationsContextType } from '../context';
import { EventTypeEvaluationsProvider } from '../context';
import { UserContext } from '~/dashboard/context';
import { PersonUpdatedTabs } from './PersonUpdatedTabs';
import { PersonUpdatedOverview } from './PersonUpdatedOverview';
import { useRiskData } from '../../RiskRatingCard/useRiskData';
import { shouldRenderCard } from '../../utils/shouldRenderCard';
import { hasWatchlistServiceConfigured } from '../../utils/cardDataChecks';

const PersonUpdated: React.FC<EventTypeEvaluationsContextType> = props => {
  const { evaluation } = props;
  const { featureFlags, permissions } = useContext(UserContext);
  const hasReadApplicationVersionsPermission = !!permissions?.['READ:ApplicationVersions:null'];
  /* ---------- CRA Logic ---------- */
  const {
    showRiskTab: shouldRenderRiskTab,
    ...riskData
  } = useRiskData({
    riskScoreData: evaluation.final_response.summary?.risk_score,
  });

  /* ---------- vvvvvvvvv ---------- */

  const shouldRenderWatchlistTab = useMemo(() => (
    featureFlags?.eventEvalImprovements
    && shouldRenderCard(
      hasWatchlistServiceConfigured(evaluation),
      Boolean(featureFlags?.removeEmptyCards),
    )
  ), [evaluation, featureFlags]);

  return (
    <EventTypeEvaluationsProvider {...props}>
      <Container
        evaluationToken={evaluation.evaluation_token}
        entityToken={evaluation.entity_token}
        workflowToken={evaluation.application_token}
        workflowVersion={evaluation.public_version}
      >
        {shouldRenderRiskTab || shouldRenderWatchlistTab
          ? (
            <PersonUpdatedTabs
              canViewRiskFormula={hasReadApplicationVersionsPermission}
              riskData={riskData}
              shouldRenderRiskTab={shouldRenderRiskTab}
              shouldRenderWatchlistTab={shouldRenderWatchlistTab}
            />
          ) : (
            <PersonUpdatedOverview />
          )}
      </Container>
    </EventTypeEvaluationsProvider>
  );
};

export default PersonUpdated;
